module.exports = __webpack_public_path__ + "static/q19_o-5c8b1b4454cbe53aae58b5fb73b1c07e.png";